<template>
  <div class="properties">
    <div v-if="loader" class="loader">
      <img src="~@/assets/loader.gif" alt="" />
      <p>Carregando informações do empreendimento...</p>
    </div>
    <section v-if="!loader" class="properties-header">
      <div class="main-image" @click="showModal = true">
        <img alt="" :src="properties.banner" />
      </div>
    </section>
    <section v-if="!loader" class="properties-main">
      <div class="container">
        <div class="section">
          <div class="first-column">
            <div class="buttons">
              <button
                class="gallery-button"
                @click="showModal = true"
                v-if="properties.images.length"
              >
                <img src="~@/assets/icon-image.svg" alt="gallery-button" />
                Galeria de fotos
              </button>

              <button
                class="gallery-button"
                v-if="properties.video_url"
                @click="showVideo = true"
              >
                <img src="~@/assets/icon-play.svg" alt="gallery-button" />
                Vídeo
              </button>
            </div>
            <h2>{{ properties.name }}</h2>
            <p class="properties-info">
              {{ buildingDetail }}
            </p>
            <p
              v-if="properties.city && properties.state"
              class="properties-info"
            >
              {{ properties.city.name }} - {{ properties.state.name }}
            </p>
            <div class="post-content" v-html="properties.description"></div>
          </div>
          <div class="second-column is-hidden-mobile">
            <contact-form />
          </div>
        </div>

        <button class="button-primary" @click="openWhatsappModal">
          Fale com um especialista
        </button>
        
        <div
          class="property-price"
          v-if="properties.price != null && properties.price != 'null'"
        >
          <h2>
            Investimento
          </h2>
          <h3>
            A partir de:
            {{ formattedPrice }}
          </h3>
          <p
            v-if="
              properties.promotion_text != null &&
                properties.promotion_text != 'null'
            "
          >
            {{ properties.promotion_text }}
          </p>
        </div>

        <div
          class="benefits"
          v-if="privateFeatures.length > 0 || publicFeatures.length > 0"
        >
          <h2>O que oferece este empreendimento</h2>
          <div class="private-areas" v-if="privateFeatures.length > 0">
            <h4>Área Privativas</h4>
            <ul>
              <li v-for="feature in privateFeatures" :key="feature.id">
                <p>{{ feature.name }}</p>
              </li>
            </ul>
          </div>
          <div class="comum-areas" v-if="publicFeatures.length > 0">
            <h4>Áreas Comuns</h4>
            <ul>
              <li v-for="feature in publicFeatures" :key="feature.id">
                <p>{{ feature.name }}</p>
              </li>
            </ul>
          </div>
        </div>

        <button class="button-primary" @click="openWhatsappModal">
          Fale com um especialista
        </button>

        <div class="localization" v-if="renderLocalization">
          <h2>Conheça a vizinhança do empreendimento</h2>
          <div class="content">
            <div class="firstColumn">
              <map-box-loader
                :location="location"
                :editMode="false"
                v-if="renderMap"
              />
            </div>
            <div
              v-if="properties.neighborhood_description != `null`"
              class="secondColumn"
              v-html="properties.neighborhood_description"
            ></div>
          </div>
        </div>

        <button class="button-primary" @click="openWhatsappModal">
          Fale com um especialista
        </button>

        <div class="is-hidden-tablet">
          <contact-form />
        </div>

        <!-- Referência ao componente WhatsApp -->
        <WhatsAppButton ref="whatsappRef" />
      </div>
    </section>

    <modal
      @close="showModal = false"
      v-show="showModal && properties.images.length"
      class="modal-images-property"
    >
      <template v-slot:body>
        <div class="imob-gallery">
          <div class="imob-gallery_main">
            <img :src="showImage" alt="" />
          </div>
          <div class="imob-gallery_controls">
            <a @click="prevImage()"
              ><img src="@/assets/arrow-left-modal.svg" alt=""
            /></a>
            <a @click="nextImage()"
              ><img src="@/assets/arrow-right-modal.svg" alt=""
            /></a>
          </div>
          <div class="imob-gallery_thumbnails">
            <ul>
              <li v-for="(image, index) in properties.images" :key="index">
                <img :src="image" alt="" @click="activateImage(image, index)" />
              </li>
            </ul>
          </div>
        </div>
      </template>
    </modal>
    <modal @close="showVideo = false" v-show="showVideo">
      <template v-slot:body>
        <iframe
          id="player"
          type="text/html"
          style="width: 100%; height: 470px;"
          :src="properties.video_url"
          frameborder="0"
        ></iframe>
      </template>
    </modal>
  </div>
</template>

<script>
import { buildingsService } from "@/services/buildings.service";

import ContactForm from "@/components/properties/ContactForm";
import MapBoxLoader from "@/components/maps/MapBoxLoader";
import Modal from "@/components/shared/Modal";

import WhatsAppButton from '@/components/WhatsAppButton.vue'

export default {
  name: "Properties",

  components: {
    WhatsAppButton,
    ContactForm,
    MapBoxLoader,
    Modal
  },

  data() {
    return {
      showImage: "",
      loader: false,
      showModal: false,
      showVideo: false,
      properties: {},
      features: [],
      location: [],
      activeImage: 0,
      localArrayImages: []
    };
  },

  computed: {
    privateFeatures() {
      const features = this.properties?.features;
      if (features != null && features.length > 0) {
        return features.filter(feature => feature.private_area);
      } else {
        return [];
      }
    },

    publicFeatures() {
      const features = this.properties?.features;
      if (features != null && features.length > 0) {
        return features.filter(feature => !feature.private_area);
      } else {
        return [];
      }
    },

    renderMap() {
      return !!this.location.length && this.location.every(e => !!e);
    },

    formattedPrice() {
      return new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL"
      }).format(this.properties.price / 100);
    },

    buildingDetail() {
      var value = "";

      const type = this.getPropertyType;
      const area = this.properties.area;
      const bedrooms = this.properties.bedrooms;

      if (type != null) {
        value += type;
      }

      if (area != null) {
        value += ` - ${area} m²`;
      }

      if (bedrooms != null) {
        let bedroomLabel = bedrooms === 1 ? "quarto" : "quartos";
        value += ` - ${bedrooms} ${bedroomLabel}`;
      }

      return value;
    },

    getPropertyType() {
      const type = this.properties.property_type;
      var value = null;

      switch (type) {
        case "apartment":
          value = "Apartamento";
          break;
        case "house":
          value = "Casa";
          break;
        case "room":
          value = "Sala";
          break;
        case "shop":
          value = "Loja";
          break;
        case "allotment":
          value = "Loteamento";
          break;
      }
      return value;
    },

    renderLocalization() {
      return (
        (this.properties.latitude &&
          this.properties.longitude &&
          this.properties.latitude !== "null" &&
          this.properties.longitude !== "null") ||
        (this.properties.neighborhood_description &&
          this.properties.neighborhood_description !== "null")
      );
    }
  },

  mounted() {
    this.getInfoProperties(this.$route.params.id);
  },

  methods: {
    openWhatsappModal() {
      // Acessa o componente filho via ref e mostra o modal
      this.$refs.whatsappRef.showModal = true
    },

    async getInfoProperties(id) {
      try {
        const infosProperties = await buildingsService.getBuildingById(id);
        this.properties = infosProperties.data.data.attributes;
        this.showImage = infosProperties.data.data.attributes.images[0];
        this.location = [
          parseFloat(infosProperties?.data?.data?.attributes?.longitude),
          parseFloat(infosProperties?.data?.data?.attributes?.latitude)
        ];
        this.localArrayImages = infosProperties.data.data.attributes.images;
        this.loader = false;
      } catch (error) {
        console.log("Ocorreu um erro inesperado.");
      }
    },

    activateImage(url, imageIndex) {
      this.showImage = url;
      this.activeImage = imageIndex;
    },

    nextImage() {
      if (this.activeImage + 1 < this.localArrayImages.length) {
        this.activeImage = this.activeImage + 1;
        this.showImage = this.localArrayImages[`${this.activeImage}`];
      }
    },

    prevImage() {
      if (this.activeImage - 1 >= 0) {
        this.activeImage = this.activeImage - 1;
        this.showImage = this.localArrayImages[`${this.activeImage}`];
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.button-primary {
  margin-bottom: 20px; // ou margin: 20px 0; para margem vertical
}

.properties {
  position: relative;

  .is-hidden-mobile {
    @media (max-width: 768px) {
      display: none;
    }
  }

  .is-hidden-tablet {
    @media (min-width: 769px) {
      display: none;
    }
  }

  .modal-images-property {
    ::v-deep.modal-backoffice .modal-body {
      padding: 0px 10px 0px;
    }
  }

  .loader {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 300px;
    margin: 100px 0;
  }

  .properties-header {
    .main-image {
      background-color: #00000073;
      z-index: 0;

      img {
        width: 100%;
        height: 624px;
        object-fit: cover;
        display: block;
        overflow: hidden;
      }
    }
  }

  .properties-image {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;

    div {
      width: 100%;
      position: relative;

      &.more-images {
        display: flex;
        align-items: flex-start;
        justify-content: flex-start;
        flex: 1;
        flex-wrap: wrap;

        div {
          max-width: 459px;
          height: 100%;

          &.box-modal {
            position: relative;

            .open-modal {
              position: absolute;
              top: 0;
              width: calc(100% - 20px);
              left: 20px;
              height: calc(100% - 25px);
              background: rgba(0, 0, 0, 0.3);
              display: flex;
              align-items: center;
              justify-content: center;
              color: var(--white);
              font-size: 55px;
              cursor: pointer;
            }
          }

          &.open-modal {
            cursor: pointer;
          }
        }
        img {
          max-width: 459px;
          width: calc(100% - 20px);
          margin: 0 0 18px 20px;
          height: 221px;
          object-fit: cover;
        }
      }
    }

    .image-logos {
      position: absolute;
      bottom: -40px;
      left: 25%;
      display: flex;
      width: 302px;
      justify-content: space-between;
      align-items: center;

      img {
        display: block;
        margin: 0 !important;
        padding: 0;
      }

      .builder {
        width: auto;
        img {
          width: 100px;
          height: 100px;
        }
      }

      .button-360 {
        width: auto;
        img {
          width: 189px;
          height: 66px;
          cursor: pointer;
        }
      }
    }
  }

  .properties-main {
    margin-top: -30px;

    .container {
      max-width: 1020px;
      padding-bottom: 100px;
    }

    h2 {
      color: var(--yellow-custom);
      font-weight: 900;
      line-height: 36px;
      font-size: var(--size-h2);
      margin-bottom: 12px;
    }

    h3 {
      color: var(--yellow-custom);
      font-weight: var(--weight-bold);
      line-height: 36px;
      font-size: var(--size-h3);
      margin-bottom: 4px;
    }

    .properties-info {
      color: var(--yellow-custom);
      font-size: var(--size-regular);
      font-weight: var(--weight-semibold);
    }

    .section {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      margin-bottom: 80px;

      .first-column {
        max-width: 580px;
        width: 100%;

        .buttons {
          display: flex;
          margin-bottom: 50px;
          z-index: 99;
        }

        .gallery-button {
          display: flex;
          width: 200px;
          height: 70px;
          background-color: var(--white);
          box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.1);
          border-radius: 16px;
          border-width: 0px;
          text-align: center;
          font-size: var(--size-button);
          font-weight: bold;
          color: var(--blue-custom);
          margin-right: 20px;
          cursor: pointer;
          align-items: center;
          justify-content: center;

          img {
            padding-right: 10px;
          }
        }

        .post-content {
          padding: 0px;
          margin-top: 55px;
          color: #737b7d;
          line-height: 30px;
        }
      }

      .second-column {
        max-width: 390px;
        width: 100%;
      }
    }

    .property-price {
      margin-bottom: 70px;

      h3 {
        color: var(--blue-custom);
        font-weight: var(--weight-bold);
        padding-top: 20px;
      }

      p {
        color: var(--blue-custom);
      }
    }

    .benefits {
      display: block;
      justify-content: space-between;
      align-items: flex-start;
      margin-bottom: 60px;

      div {
        width: 100%;
        padding: 45px 38px;
        background-color: #f7f7f7;
        border-radius: 20px;
        margin-top: 30px;

        h4 {
          color: #4f4f4f;
          font-weight: var(--weight-regular);
        }

        ul {
          margin: 0;
          padding: 20px 0 0 0;
          display: block;
          column-count: 4;
          --webkit-column-count: 4;
          --moz-column-count: 4;
          // align-items: flex-start;
          // justify-content: flex-start;
          list-style: none;
          // flex: 1;
          // flex-wrap: wrap;

          li {
            padding: 10px 0;
            align-items: flex-start;
            flex-direction: column;
            justify-content: space-between;
            font-size: var(--size-base);
            line-height: 16px;
            color: var(--grey-dark-custom);
          }
        }
      }
    }

    .localization {
      display: block;
      margin-bottom: 90px;

      .content {
        display: flex;
        justify-content: space-between;
        padding-top: 60px;

        .firstColumn {
          max-width: 60%;
          width: 100%;

          #map {
            height: 290px;
          }
        }

        .secondColumn {
          max-width: 40%;
          width: 100%;
          line-height: 29px;
          font-weight: var(--weight-light);
          color: #737b7d;
          padding-left: 20px;
        }
      }
    }
  }

  @media (max-width: 768px) {
    margin-top: 0px;

    .properties-header {
      margin-top: 60px;
      height: auto;
      position: initial;

      .container {
        flex-direction: column;
        align-items: flex-start;
      }

      .main-image {
        img {
          height: 370px;
        }
      }

      ul {
        margin-bottom: 16px;
        li {
          font-size: var(--size-regular);
        }
      }
    }

    .properties-image {
      flex-direction: column;

      div.main-image {
        margin-bottom: 68px;
        width: 100%;

        img {
          height: 248px;
        }
      }

      .more-images {
        width: 100%;

        div {
          width: 50%;
          img {
            width: calc(100% - 10px);
            margin: 0 5px 3px 5px;
            height: auto;
          }
        }
      }

      .image-logos {
        bottom: -70px;
        left: inherit;
        width: 100%;
        text-align: center;
        padding: 0 16px;
      }
    }

    .properties-main {
      .container {
        padding-top: 30px;
        padding-bottom: 60px;
      }

      .section,
      .property-price,
      .benefits,
      .localization,
      .contact {
        flex-direction: column;
        margin-bottom: 40px;

        div:first-child {
          margin-bottom: 16px;
        }
      }

      .benefits {
        div {
          ul {
            column-count: 1;
            --webkit-column-count: 1;
            --moz-column-count: 1;

            li {
              width: 47%;
              display: block;
            }
          }
        }
      }

      .localization {
        .content {
          display: block;

          .firstColumn {
            max-width: 100%;
          }

          .secondColumn {
            max-width: 100%;
            margin-top: 20px;
          }
        }
        img {
          width: 100%;
        }
      }

      .contact {
        div:last-child {
          &::before,
          &::after {
            display: none;
          }

          height: auto;
          padding: 20px;
        }
      }
    }
  }
}

.imob-gallery {
  position: relative;

  .imob-gallery_main {
    max-width: 845px;
    margin: 0 auto;
    img {
      max-width: 845px;
      width: 100%;
      height: 517px;
      object-fit: cover;
      border-radius: 10px;

      @media (max-width: 768px) {
        height: 280px;
      }

      @media (max-width: 320px) {
        height: 180px;
      }
    }
  }

  .imob-gallery_controls {
    position: absolute;
    bottom: calc(50% + 15px);
    width: 100%;
    display: flex;
    justify-content: space-between;

    a {
      cursor: pointer;
    }

    @media (max-width: 768px) {
      display: none;
    }
  }

  .imob-gallery_thumbnails {
    max-width: 845px;
    margin: 16px auto 0;
    ul {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      list-style: none;
      li {
        margin: 0 16px 0 0;
        cursor: pointer;

        img {
          width: 156px;
          height: 111px;
          border-radius: 10px;
          object-fit: cover;
        }
      }
    }

    @media (min-width: 1024px) {
      ul {
        max-width: 845px;
        overflow-x: scroll;
      }
    }

    @media (max-width: 768px) {
      ul {
        justify-content: space-between;
        flex: 1;
        flex-wrap: wrap;
        li {
          margin: 0 0;

          img {
            width: 114px;
            height: 81px;
          }
        }
      }
    }

    @media (max-width: 320px) {
      ul {
        li {
          img {
            width: 120px;
            height: 65px;
          }
        }
      }
    }
  }
}
</style>
